import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { QueryParamsService } from 'src/app/app-services/query-params-service';
import urls from 'src/app/strings/urls.json';
import { environment } from 'src/environments/environment';

import { UserDataService } from '../../app-services/user-data-service';
import { ContinueOnlineModalComponent } from '../eligibility-quiz-channels/continue-online-modal/continue-online-modal.component';

@Component({
  selector: 'app-eligibility-quiz-instructions',
  standalone: true,
  imports: [RouterModule, CommonModule, ContinueOnlineModalComponent],
  templateUrl: './eligibility-quiz-instructions.component.html',
  styleUrls: ['./eligibility-quiz-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EligibilityQuizInstructionsComponent {
  constructor(
    private queryParamService: QueryParamsService,
    private userDataService: UserDataService,
  ) {}

  @ViewChild(ContinueOnlineModalComponent) continueOnlineModal!: ContinueOnlineModalComponent;

  public urls = urls;

  onCreateReportLinkClick(event: MouseEvent): void {
    event.preventDefault();

    const injuryType = this.userDataService.getData('injuryType');
    const payload = { injuryType };
    const encodedPayload = btoa(JSON.stringify(payload));

    this.queryParamService.setParams({ EQQA: encodedPayload });

    const queryString = this.queryParamService.getQueryParamsString();
    const redirectUrl = queryString ? `${environment.wrioUrl}?${queryString}` : environment.wrioUrl;

    // Navigate to the URL
    window.location.href = redirectUrl;
  }
}
